__turbopack_context__.v({
  "bvMedia": "Rlfy0q_bvMedia",
  "pricing": "Rlfy0q_pricing",
  "root": "Rlfy0q_root",
  "specBlock": "Rlfy0q_specBlock",
});
